import { useQuery } from '@tanstack/react-query';
import { queryKeys, missionControlService } from '@v2/services';
import type { DefaultMissionControlVersion } from '@v2/types';

interface UseDefaultMissionControlVersionResult {
  version: DefaultMissionControlVersion | null;
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export const useDefaultMissionControlVersion =
  (): UseDefaultMissionControlVersionResult => {
    const query = useQuery({
      queryKey: queryKeys.missionControl.versions.default(),
      queryFn: missionControlService.getDefaultVersion,
    });

    return {
      version: query.data ?? null,
      loading: query.isLoading,
      error: query.error instanceof Error ? query.error.message : null,
      refetch: async () => {
        await query.refetch();
      },
    };
  };

export default useDefaultMissionControlVersion;
